import { useState } from 'react';

import { useRouter } from 'next/router';

import { useQuery, useMutation } from 'react-query';
import { downloadFile } from 'utils/fileConvert';
import { exportCoverLetterPDF, coverLetterService } from 'services/coverLetter';
import Modal from '@core/components/Modal/Modal';
import { MOBILE_SLIDE_UP, CONFIRMATION } from '@core/constants/ModalTypes';
import LinkButton from '@core/components/linkbutton/LinkButton';
import ActionButton from '@core/components/actionbutton/ActionButton';

import UseModal from 'hooks/use-modal';
import UseToast from 'hooks/use-toast';

import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

import CoverLetterDraftImage from 'assets/images/cover-letter-draft.png';
import CoverLetterExportedImage from 'assets/images/cover-letter-exported.png';
import MenuBulletIcon from 'assets/icons/menu-bullet-icon.svg';

import classes from './CoverLetterCard.module.scss';

const CoverLetterCard = ({ data, deleteHandler, hasSubscription, showGoPremiumModal }) => {
    const { ToastContainer, toast } = UseToast();
    const router = useRouter();
    const {
        destroyModal: destroyConfirmModal,
        show: showConfirmModal,
        showModal: handleShowConfirmtModal
    } = UseModal();
    const {
        destroyModal: destroySortModal,
        show: showSortModal,
        showModal: handleShowSortModal
    } = UseModal();
    const [anchorEl, setAnchorEl] = useState(null);
    const { data: cv_pdf, isFetching, error, refetch } = useQuery(['user-coverletter-export', data.id], () => exportCoverLetterPDF(data.id),
        {
            onSuccess: (cv_pdf) => {
                downloadFile(cv_pdf);
                if (data.status !== 'exported')
                    router.push('/cover-letter/preview/' + exportId);
            },
            refetchOnMount: 'always',
            cacheTime: 0,
            enabled: false,
        });
    const { mutate: deleteCoverLetter } = useMutation(coverLetterService.DELETE, {
        onSuccess: (data) => {
            deleteHandler();
        },
        onError: (error) => {
            toast(getErrorText(error), 'Alert');
        }
    });
    const handleClick = (event) => {
        hasSubscription ? setAnchorEl(event.currentTarget) : showGoPremiumModal() ;
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    return (
        <>
            <div className={classes["cover-letter-card-wrapper"]}>
                <img className='d-none d-md-block' src={data.status === 'draft' ? (CoverLetterDraftImage.src) : (CoverLetterExportedImage.src)} alt='Cover Letter Icon' />
                <div className={`${classes["mobile-card-header"]} d-flex d-md-none justify-content-between`}>
                    <img className={classes["mobile-card-icon"]} src={data.status === 'draft' ? (CoverLetterDraftImage.src) : (CoverLetterExportedImage.src)} alt='Cover Letter Icon' />
                    <Button
                        className={`d-block d-md-none`}
                        variant="text"
                        onClick={() => hasSubscription ? handleShowSortModal() : showGoPremiumModal()}>
                        <MenuBulletIcon />
                    </Button>
                </div>
                <div className={classes["card-data"]}>
                    <div className={`${classes["name-menu"]} pt-3 pt-md-0`}>
                        <div className={classes["name"]}>
                            {data.name}
                        </div>
                        <div className={classes["menu"]}>
                            <Button
                                id="action-button"
                                className={`d-none d-md-block`}
                                variant="text"
                                aria-controls={!!anchorEl ? 'basic-menu' : undefined}
                                aria-haspopup="true"
                                aria-expanded={!!anchorEl ? 'true' : undefined}
                                onClick={handleClick}>
                                <MenuBulletIcon />
                            </Button>

                            {data.status === 'draft' ? (
                                <Menu
                                    id="basic-menu"
                                    anchorEl={anchorEl}
                                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                                    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                                    open={!!anchorEl}
                                    onClose={handleClose}
                                    onClick={handleClose}
                                    className={classes['action-desktop-wrapper']}
                                    MenuListProps={{
                                        'aria-labelledby': 'basic-button'
                                    }}>
                                    <MenuItem onClick={() => router.push('/cover-letter/edit/' + data.id)}>
                                        Edit
                                    </MenuItem>
                                    <MenuItem onClick={() => router.push('/cover-letter/preview/' + data.id)}>
                                        View details
                                    </MenuItem>
                                    {/* <MenuItem onClick={() => deleteCoverLetter(data.id)} > */}
                                    <MenuItem onClick={() => handleShowConfirmtModal()}>
                                        Delete
                                    </MenuItem>
                                </Menu>
                            ) : (
                                <Menu
                                    id="basic-menu"
                                    anchorEl={anchorEl}
                                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                                    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                                    open={!!anchorEl}
                                    onClose={handleClose}
                                    onClick={handleClose}
                                    className={classes['action-desktop-wrapper']}
                                    MenuListProps={{
                                        'aria-labelledby': 'basic-button'
                                    }}>
                                    <MenuItem onClick={() => router.push('/cover-letter/preview/' + data.id)}>
                                        View Document
                                    </MenuItem>
                                    <MenuItem onClick={() => refetch()}>
                                        Download PDF
                                    </MenuItem>
                                    <MenuItem onClick={() => handleShowConfirmtModal()}>
                                        Delete
                                    </MenuItem>
                                </Menu>
                            )}


                        </div>
                    </div>
                    <div className={classes["date"]}>
                        {data.created_date}
                    </div>
                    <div className={classes["role"]}>
                        {(data.role_applied_for !== null) && (
                            <>
                                Role: {data.role_applied_for}
                            </>
                        )}
                    </div>
                    <div className={classes["badge"]}>
                        {data.status === "draft" ? (
                            <div className={classes["draft"]}>
                                Draft
                            </div>
                        ) : (
                            <div className={classes["exported"]}>
                                PDF
                            </div>
                        )}
                    </div>
                </div>
            </div >
            <Modal
                type={MOBILE_SLIDE_UP}
                title="Actions"
                show={showSortModal}
                closeHandler={destroySortModal}>
                <div
                    className={`${classes["modal-menu-wrapper"]} d-flex flex-column align-items-start`}
                    style={{ minWidth: '50vw' }}
                >
                    {data.status === 'draft' ? (
                        <>
                            <LinkButton kind="simple" to={'/cover-letter/edit/' + data.id}>
                                Edit
                            </LinkButton>
                            <LinkButton kind="simple" to={'/cover-letter/preview/' + data.id}>
                                View details
                            </LinkButton>
                            <ActionButton kind="blank" onClick={() => handleShowConfirmtModal()}>
                                Delete
                            </ActionButton>
                        </>
                    ) : (
                        <>
                            <LinkButton kind="simple" to={'/cover-letter/preview/' + data.id}>
                                View Document
                            </LinkButton>
                            <ActionButton kind="blank" onClick={() => refetch()}>
                                Download PDF
                            </ActionButton>
                            <ActionButton kind="blank" onClick={() => handleShowConfirmtModal()}>
                                Delete
                            </ActionButton>
                        </>
                    )}

                </div>
            </Modal>
            <Modal
                title="Delete Cover Letter?"
                header={false}
                show={showConfirmModal}
                closeHandler={destroyConfirmModal}
                type={CONFIRMATION}
                >
                <div
                    className={`${classes["modal-confirmation"]} d-flex flex-column align-items-start`}
                    style={{ minWidth: '50vw' }}
                >
                    <h3>Delete Cover Letter?</h3>
                    <p>Are you sure you want to permanently delete cover letter “{data.name}”?</p>
                    <div className='d-flex justify-content-end w-100 mt-4'>
                        <ActionButton kind='simple' onClick={() => destroyConfirmModal()}>Cancel</ActionButton>
                        <ActionButton kind='simple-alert' onClick={() => deleteCoverLetter(data.id)}>Delete</ActionButton>
                    </div>
                </div>
            </Modal>
            <ToastContainer />
        </>
    );
};

export default CoverLetterCard;